export default __webpack_public_path__ + "static/media/q-completed-img.ddea363c.svg";